import { wpFetch } from 'src/helpers/wpApiHandler';

const useCreateNewLead = async (bodyData) => {
  const response = await wpFetch(['create-lead'], {
    method: 'POST',
    body: bodyData,
  });

  return response;
};

export default useCreateNewLead;
